import { render, staticRenderFns } from "./Pdfpreview.vue?vue&type=template&id=3242a7d2&"
import script from "./Pdfpreview.vue?vue&type=script&lang=ts&"
export * from "./Pdfpreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports